var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-color"},[_c('p',{staticClass:"metafield__title"},[_vm._v(_vm._s(_vm.field.label))]),_vm._v(" "),_c('ColorPicker',{attrs:{"value":_vm.value || '#000000',"disableAlpha":true},on:{"input":_vm.onInput}}),_vm._v(" "),(_vm.hint)?_c('TypographyInputHint',[_vm._v(_vm._s(_vm.hint))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-543c63a1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditColor.vue
// module id = 616
// module chunks = 0